import { Component } from '@angular/core';
import { DiscussionPageBaseComponent } from '../../shared/discussion-page-base/discussion-page-base.component';

@Component({
  selector: 'app-discussion-general',
  standalone: true,
  imports: [DiscussionPageBaseComponent],
  template: `
    <app-discussion-page-base
      pageTitle="General"
      pageDescription="General discussions covering a wide range of topics. Share your thoughts, experiences, and insights with the community."
      activeTab="general"
      categoryType="GENERAL"
    ></app-discussion-page-base>
  `,
})
export class DiscussionGeneralComponent {}
